import { FC } from "react";
import clsx from "clsx";
import styles from "./Timeframes.module.scss";
import { TimeFrames } from "../../../../types";
// TODO: TipRanks api does not provide all timeframes.
// export enum TimeFrames {
//     M1 = "1m",
//     M5 = "5m",
//     M15 = "15m",
//     M30 = "30m",
//     H1 = "1h",
//     H5 = "5h",
//     D1 = "1d",
//     W1 = "1w",
//     MON1 = "1M",
// }

interface ITimeframesPanelProps {
    onChange: (timeframe: TimeFrames) => void;
    selected: string;
}

const getTitle = (timeframe: TimeFrames) => {
    switch (timeframe) {
        case TimeFrames.D1:
            return "1 Day";
        case TimeFrames.D3:
            return "3 Days";
        case TimeFrames.W1:
            return "1 Week";
        case TimeFrames.W2:
            return "2 Weeks";
        case TimeFrames.MON1:
            return "1 Month";
        default:
            return "";
    }
};

export const TimeFramesPanel: FC<ITimeframesPanelProps> = ({ onChange, selected }) => {
    return (
        <div className={styles.timeFrames}>
            {Object.values(TimeFrames).map((timeframe, index) => (
                <div
                    title={getTitle(timeframe)}
                    onClick={() => onChange(timeframe)}
                    key={index}
                    className={clsx(styles.item, {
                        [styles.selected]: selected === timeframe,
                    })}>
                    <span>{timeframe.slice(0, timeframe.length - 1)}</span>
                    <span>
                        <sup>{timeframe.slice(-1)}</sup>
                    </span>
                </div>
            ))}
        </div>
    );
};
